import axios from "axios"

export default {
  getAdAccountPages(adAccountId) {
    const url = `/fam/adaccounts/${adAccountId}/pages`

    return axios.get(url).then(response => {
      return response.data
    })
  },

  getBusinessPages(businessId) {
    const url = `/fam/businesses/${businessId}/pages`

    return axios.get(url).then(response => {
      return response.data
    })
  },
}
